import { render, staticRenderFns } from "./IconElement.vue?vue&type=template&id=1c6f3631&scoped=true"
import script from "./IconElement.vue?vue&type=script&lang=js"
export * from "./IconElement.vue?vue&type=script&lang=js"
import style0 from "./IconElement.vue?vue&type=style&index=0&id=1c6f3631&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c6f3631",
  null
  
)

export default component.exports